import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_SPECIAL_CASE_MUTATION } from '../graphql/mutations'
import { transformToSaveIngredientSpecialCaseArgs } from '../graphql/transformers'
import { UPSERT_INGREDIENT_SPECIAL_CASE } from '../redux/action-types'

const useUpdateIngredientSpecialCaseMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredientSpecialCase,
  )

  const mutate = useCallback(
    (id, ingredientSpecialCaseData) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_SPECIAL_CASE_MUTATION,
        {
          id,
          data: transformToSaveIngredientSpecialCaseArgs(
            ingredientSpecialCaseData,
          ),
        },
        dispatch,
        UPSERT_INGREDIENT_SPECIAL_CASE,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateIngredientSpecialCaseMutation
